<div class="card p-0 m-0 shadow-none">
  <div *ngIf="community; then Community; else Unsplash"></div>
</div>

<ng-template #Community>
  <div class="card-header bg-transparent p-0">
    <ul
      ngbNav
      #customNav="ngbNav"
      class="nav-tabs nav-tabs-custom nav-justified">
      <li [ngbNavItem]="1">
        <a ngbNavLink class=""> My Photos </a>
        <ng-template ngbNavContent>
          <app-user-media
            *ngIf="community"
            [community]="community"
            (emitter)="emitter.emit($event)"></app-user-media>
        </ng-template>
      </li>
      <li [ngbNavItem]="2">
        <a ngbNavLink class="">Stock Photos</a>
        <ng-template ngbNavContent>
          <app-unsplash (emitter)="emitter.emit($event)"></app-unsplash>
        </ng-template>
      </li>
    </ul>
  </div>
  <div class="card-body">
    <div [ngbNavOutlet]="customNav"></div>
  </div>
</ng-template>

<ng-template #Unsplash>
  <div class="card-header bg-transparent">
    <h5 class="m-0">Unsplash Stock Photos</h5>
  </div>
  <app-unsplash (emitter)="emitter.emit($event)"></app-unsplash>
</ng-template>
